import { PaymentFieldType } from '@endeavour/payment-integration';
import { CARD_METHOD, CardFields } from './create-payment.js';

function getForm(method, isSavedAccount, providerId) {
    if (isSavedAccount) {
        // The account is a saved account, we do not need any information except cvv
        return providerId === CARD_METHOD
            ? [
                {
                    name: 'CVV',
                    key: 'CVV',
                    type: PaymentFieldType.CUSTOM,
                },
            ]
            : [];
    }
    if (providerId === CARD_METHOD) {
        return [
            {
                name: CardFields.CARD_HOLDER,
                key: CardFields.CARD_HOLDER,
                label: 'Cardholder Name',
                type: PaymentFieldType.TEXT,
            },
            {
                name: CARD_METHOD,
                key: CARD_METHOD,
                type: PaymentFieldType.CUSTOM,
            },
        ];
    }
    return (method?.fields.map((field) => ({
        name: field.name,
        key: field.name,
        type: PaymentFieldType.TEXT,
    })) ?? []);
}

export { getForm };
